const DEFAULT_DELIVERY_ADMIN_API_BASE_URL = 'http://localhost:4000';

/**
 * Resolve the delivery-admin API base URL.
 *
 * Priority:
 * 1) VITE_BFF_URL (preferred unified API host)
 * 2) VITE_API_URL
 * 3) Local BFF default
 */
export function getDeliveryAdminApiBaseUrl(): string {
  return (
    import.meta.env.VITE_BFF_URL ||
    import.meta.env.VITE_API_URL ||
    DEFAULT_DELIVERY_ADMIN_API_BASE_URL
  );
}
